//      
import memoizeOne from 'memoize-one';
                                                   

export default memoizeOne(
  (
    remove                    ,
    list                      ,
  )                       =>
    list.filter(
      (item                    ) => item.descriptor.id !== remove.descriptor.id,
    ),
);



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/remove-draggable-from-list.js